import { css } from "@emotion/react"

const customGlobalCss = css`
  html {
    font-family: "Source Sans Pro", "sans-serif";
  }
`

export default customGlobalCss
